<div class="p-4 settings-page">
  <h4 class="mb-1">Atualizar conexão</h4>
  <div class="text-muted mb-3">Conexão: <span class="font-monospace">{{ connectionId }}</span></div>

  <div class="d-flex justify-content-center" *ngIf="loading()">
    <app-progress-spinner class="m-auto"></app-progress-spinner>
  </div>

  <form [formGroup]="form" class="card p-3" *ngIf="!loading()">
    <div class="mb-3">
      <label class="form-label">Imagem do WAHA</label>
      <div class="input-group">
        <select class="form-select waha-image-source" formControlName="wahaImageSource">
          <option *ngFor="let source of wahaImageSources()" [value]="source">{{ source }}</option>
        </select>
        <input type="text" class="form-control" formControlName="wahaImageTag" placeholder="latest" />
      </div>
      <div class="form-text" *ngIf="runningWahaImages().length"
           [class.text-warning-emphasis]="isWahaImageOutOfSync()">
        Em execução: <span class="font-monospace">{{ runningWahaImages().join(', ') }}</span>
        <ng-container *ngIf="isWahaImageOutOfSync()">
          — difere do configurado acima, que só chega no pod depois do rollout.
        </ng-container>
      </div>
      <div class="text-danger" *ngIf="form.get('wahaImageTag')?.touched && form.get('wahaImageTag')?.hasError('required')">
        Campo obrigatório
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Nível mínimo de log do WAHA</label>
      <select class="form-select" formControlName="wahaLogLevel">
        <option *ngFor="let level of logLevels" [value]="level">{{ level }}</option>
      </select>
    </div>

    <div class="form-check mb-3">
      <input class="form-check-input" type="checkbox" formControlName="wahaEnableTagEvents" id="wahaEnableTagEventsSingle" />
      <label class="form-check-label" for="wahaEnableTagEventsSingle">
        Habilitar eventos de tag
      </label>
    </div>

    <div class="mb-3">
      <label class="form-label">Imagem do Nibo WAHA</label>
      <div class="input-group">
        <span class="input-group-text">{{ niboWahaImagePrefix }}</span>
        <input type="text" class="form-control" formControlName="niboWahaImageTag" placeholder="1.2.3" />
      </div>
      <div class="form-text" *ngIf="runningNiboWahaImages().length"
           [class.text-warning-emphasis]="isNiboWahaImageOutOfSync()">
        Em execução: <span class="font-monospace">{{ runningNiboWahaImages().join(', ') }}</span>
        <ng-container *ngIf="isNiboWahaImageOutOfSync()">
          — difere do configurado acima, que só chega no pod depois do rollout.
        </ng-container>
      </div>
      <div class="text-danger" *ngIf="form.get('niboWahaImageTag')?.touched && form.get('niboWahaImageTag')?.hasError('required')">
        Campo obrigatório
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Versão do Chart do Nibo WAHA</label>
      <input type="text" class="form-control" formControlName="niboWahaChartVersion" />
      <div class="text-danger" *ngIf="form.get('niboWahaChartVersion')?.touched && form.get('niboWahaChartVersion')?.invalid">
        Campo obrigatório
      </div>
    </div>

    <hr />
    <h6 class="mb-2">VPA — limites de memória do WAHA</h6>
    <div class="text-muted small mb-3">
      Aceita unidades K8s (ex.: <span class="font-monospace">900Mi</span>, <span class="font-monospace">2253Mi</span>).
      Evite valores fracionários de Gi (ex.: 2.5Gi) — use Mi.
    </div>

    <div class="mb-3">
      <label class="form-label">VPA minAllowed (memória)</label>
      <input type="text" class="form-control" formControlName="vpaConfigWAHAMinAllowedMemory" placeholder="ex: 900Mi" />
      <div class="text-danger" *ngIf="form.get('vpaConfigWAHAMinAllowedMemory')?.touched && form.get('vpaConfigWAHAMinAllowedMemory')?.hasError('required')">
        Campo obrigatório
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">VPA maxAllowed (memória)</label>
      <input type="text" class="form-control" formControlName="vpaConfigWAHAMaxAllowedMemory" placeholder="ex: 2253Mi" />
      <div class="text-danger" *ngIf="form.get('vpaConfigWAHAMaxAllowedMemory')?.touched && form.get('vpaConfigWAHAMaxAllowedMemory')?.hasError('required')">
        Campo obrigatório
      </div>
    </div>

    <hr />
    <h6 class="mb-2">Disco de sessão (por conexão)</h6>
    <div class="text-muted small mb-3">
      Tamanho do volume (PVC) desta conexão. Configuração exclusiva por conexão — não existe valor global/default.
      O crescimento automático (webhooks do Datadog) vai até <span class="font-monospace">8Gi</span>;
      <span class="font-monospace">16Gi</span> deve ser usado apenas manualmente em casos raros de disco cheio persistente.
      <br />
      <strong>O Kubernetes só permite aumentar o disco, nunca reduzir.</strong>
      Tamanho atual: <span class="font-monospace">{{ currentVolumeSize() }}</span>.
    </div>

    <div class="mb-3">
      <label class="form-label">VolumeSize</label>
      <select class="form-select" formControlName="volumeSize">
        <option *ngFor="let size of volumeSizes" [value]="size" [disabled]="isVolumeSizeDisabled(size)">
          {{ size }}{{ isVolumeSizeDisabled(size) ? ' (menor que o atual)' : '' }}
        </option>
      </select>
      <div class="text-danger" *ngIf="form.get('volumeSize')?.touched && form.get('volumeSize')?.hasError('required')">
        Campo obrigatório
      </div>
    </div>

    <div class="d-flex gap-2">
      <button type="button" class="btn btn-primary" (click)="save()" [disabled]="saving()">Atualizar conexão</button>
      <a class="btn btn-outline-secondary" [routerLink]="['/whatsapp/connections']" [class.disabled]="saving()">Voltar</a>
    </div>
  </form>
</div>
